import { notification } from 'antd';
import type { NotificationInstance } from 'antd/es/notification/interface';
import React, { createContext, useContext, useMemo } from 'react';

const NotificationContext = createContext<NotificationInstance | null>(null);

const NOOP = () => {};
// Module-level so callers can list the instance as a hook dependency without re-running every render.
const NOOP_NOTIFICATION: NotificationInstance = {
  success: NOOP,
  error: NOOP,
  info: NOOP,
  warning: NOOP,
  open: NOOP,
  destroy: NOOP,
};

export const NotificationContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [api, contextHolder] = notification.useNotification();

  const contextValue = useMemo(() => api, [api]);

  return (
    <NotificationContext.Provider value={contextValue}>
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = (): NotificationInstance => {
  const context = useContext(NotificationContext);
  if (!context) {
    console.error(
      'useGlobalNotification must be used within a NotificationProvider; notification will not be rendered'
    );
    return NOOP_NOTIFICATION;
  }
  return context;
};
